import { Typography, TypographyVariants, TypographyWeights } from '@carboledger/ui';
import styles from './PageHeader.module.scss';

/**
 * Props:
 *   title        the page heading
 *   breadcrumbs  the trail above the title
 *   actions      trailing controls
 */
export const PageHeader = ({ title, breadcrumbs = null, actions = null }) => {
  return (
    <div className={styles.header}>
      {breadcrumbs && <div className={styles.breadcrumbs}>{breadcrumbs}</div>}
      <div className={styles.row}>
        <div className={styles.titles}>
          <Typography variant={TypographyVariants.h5} weight={TypographyWeights.semibold}>
            {title}
          </Typography>
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
    </div>
  );
};
